import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { EventUsers } from "../../types/Types";

interface UseGetUserProps {
  id: string;
  enabled?: boolean;
}

export function useGetEventUsers({ id, enabled = true }: UseGetUserProps) {
  return useQuery({
    enabled,
    queryKey: ["eventUsers", id],
    queryFn: async () => {
      const response = await axiosInstance<unknown>(
        getAPIURL(`/Event/event/${id}/users`),
      );
      const data = response.data as Record<string, unknown> | null | undefined;
      if (!data) {
        return { eventId: Number(id) || 0, users: [] } as EventUsers;
      }
      const users = (data.users ?? data.Users ?? []) as EventUsers["users"];
      const eventId = Number(data.eventId ?? data.EventId ?? id) || 0;
      return { eventId, users };
    },
  });
}
